import { useForm, FormProvider } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { EmailFormField, TermsFormField } from "@/components/molecules";
import React, { useEffect, useState } from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import config from "@/libs/config";

export type ConnectBoardProvisionalRegistrationFormValues = {
  email: string;
  termOfUse: boolean;
  specialTerm: boolean;
  privacyPolicy: boolean;
  adEmailDelivery: boolean;
};

type Props = {
  onSubmit: (formValues: ConnectBoardProvisionalRegistrationFormValues) => void;
};

/**
 * @summary ProvisionalRegistrationForm と同一の内容だが今後の拡張性のために別のコンポーネントとしている
 * @param props
 */
export const ConnectBoardProvisionalRegistrationForm = (props: Props) => {
  const isSpMode = useIsSpMode();

  const methods = useForm<ConnectBoardProvisionalRegistrationFormValues>({
    reValidateMode: "onBlur",
  });

  // ------------------------------------------------------------
  // Update agreed value from formValues changing
  // ------------------------------------------------------------
  const [agreed, setAgreed] = useState(false);
  const formValues = methods.getValues();
  useEffect(() => {
    setAgreed(
      formValues.termOfUse &&
        formValues.specialTerm &&
        formValues.privacyPolicy &&
        formValues.adEmailDelivery
    );
  }, [formValues]);

  return (
    <>
      <div css={container}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(props.onSubmit)} css={formCSS}>
            <div css={!isSpMode ? borderBox : borderSpModeBox}>
              <div css={!isSpMode ? inputList : spModeInputList}>
                <EmailFormField name="email" />
              </div>
            </div>
            <div css={!isSpMode ? box : spModeBox}>
              <TermsFormField
                termOfUse="termOfUse"
                specialTerm="specialTerm"
                privacyPolicy="privacyPolicy"
                adEmailDelivery="adEmailDelivery"
                usingExternalIdp={config.USING_EXTERNAL_IDP}
              />
            </div>
            <div css={buttonWrapper}>
              <Button
                type="submit"
                disabled={methods.formState.isSubmitting || !agreed}
              >
                登録
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

const signInLink = css({
  textAlign: "center",
});

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  margin: "0 auto",
});

const spModeBox = css({
  padding: "15px 17px",
});

const borderBox = css(box, {
  border: `1px solid ${color.iron}`,
  padding: "32px",
  borderRadius: "4px",
});

const borderSpModeBox = css(spModeBox, {
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const formCSS = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const buttonWrapper = css({
  margin: "40px auto",
});
